// extracted by mini-css-extract-plugin
export default {"pageTitle":"pageTitle_pageTitle__fIcF6","wrapper":"pageTitle_wrapper__bRBSk","back":"pageTitle_back__IIohQ"};